import { useState } from "react";
import { api, formatApiError } from "../lib/api";

export default function FollowButton({ profile, onChange, className = "", testIdPrefix = "follow" }) {
  const [following, setFollowing] = useState(!!profile?.is_following);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  if (!profile || profile.is_self) return null;
  const targetType = profile.type === "organization" ? "org" : "user";

  const toggle = async () => {
    setBusy(true);
    setErr("");
    try {
      if (following) {
        await api.delete(`/profile/${targetType}/${profile.id}/follow`);
        setFollowing(false);
        onChange?.(false);
      } else {
        await api.post(`/profile/${targetType}/${profile.id}/follow`);
        setFollowing(true);
        onChange?.(true);
      }
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={className}>
      <button
        onClick={toggle}
        disabled={busy}
        className={following ? "csc-btn-ghost" : "csc-btn-secondary"}
        data-testid={`${testIdPrefix}-btn`}
      >
        {following ? "Following" : "+ Follow"}
      </button>
      {err && <div className="text-[11px] text-red-400 mt-1">{err}</div>}
    </div>
  );
}
